export default /* glsl */`
    writeOutput();
}
`;
